var TorsoView = require('backbone-torso/modules/View');
var PortalDataService = require('./../data-utils/PortalDataService');
var questionnaireSummaryDetailsTemplate = require('./questionnaireSummaryDetailsTemplate.hbs');

/**
 * The QuestionnaireSummaryDetailsView shows the questionnaire summary in a modal.
 *
 * @class QuestionnaireSummaryDetailsView
 * @constructor
 * @param options {Object}
 *   @param options.questionnaireResponseId {String} the response id of the questionnaire to show this view for.
 */
module.exports = TorsoView.extend(PortalDataService.mixin({
  template: questionnaireSummaryDetailsTemplate,

  /**
   * @method getQuestionnaireDisplayName
   * @returns {String} the display name of the questionnaire
   */
  getQuestionnaireDisplayName: function () {
    return this.model.get('surveyDisplayName');
  }
}));
